import { useOnboardingStore } from './onboarding.store'

export const useOnboarding = () => useOnboardingStore()
